import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import Skeleton from "@mui/material/Skeleton";
import Divider from "@mui/material/Divider";
import { CalendarClock } from "lucide-react";
import { useUpcomingSchedule } from "../../hooks/admin/use-admin-jobs";

function formatDate(dateStr: string): string {
  const date = new Date(dateStr + "T00:00:00");
  return date.toLocaleDateString("en-NZ", {
    weekday: "short",
    day: "numeric",
    month: "short",
  });
}

export function UpcomingScheduleCard() {
  const { data, isLoading } = useUpcomingSchedule();

  if (isLoading) {
    return (
      <Card variant="outlined" sx={{ p: 3, mb: 4 }}>
        <Skeleton variant="text" width={200} sx={{ mb: 1 }} />
        <Skeleton variant="text" width={160} height={36} sx={{ mb: 2 }} />
        <Skeleton variant="rectangular" height={120} />
      </Card>
    );
  }

  const hasUpcoming = data && data.upcoming.length > 0;

  return (
    <Card variant="outlined" sx={{ p: 3, mb: 4 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
        <CalendarClock size={20} />
        <Typography variant="h6" fontWeight={600}>
          Upcoming Scheduled Sends
        </Typography>
      </Box>

      {!hasUpcoming ? (
        <Typography variant="body2" color="text.secondary">
          No upcoming sends scheduled
        </Typography>
      ) : (
        <>
          <Box
            sx={{
              p: 2,
              mb: 2,
              borderRadius: 1,
              bgcolor: "primary.lighter",
              borderLeft: 3,
              borderColor: "primary.main",
            }}
          >
            <Typography variant="body2" color="text.secondary">
              Next send
            </Typography>
            <Typography variant="h5" fontWeight={700} color="primary.dark">
              {formatDate(data.nextSendDate!)}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {data.nextSendCount}{" "}
              {data.nextSendCount === 1 ? "contact" : "contacts"}
            </Typography>
          </Box>

          <Divider sx={{ mb: 2 }} />

          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            {data.upcoming.map((entry) => (
              <Box
                key={entry.date}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  py: 0.5,
                  px: 1,
                  borderRadius: 0.5,
                  "&:hover": { bgcolor: "action.hover" },
                }}
              >
                <Typography variant="body2">
                  {formatDate(entry.date)}
                </Typography>
                <Typography
                  variant="body2"
                  fontWeight={600}
                  color="text.secondary"
                >
                  {entry.contactCount}{" "}
                  {entry.contactCount === 1 ? "contact" : "contacts"}
                </Typography>
              </Box>
            ))}
          </Box>

          <Divider sx={{ my: 2 }} />

          <Typography variant="body2" color="text.secondary">
            Total scheduled: {data.totalScheduled} contacts
          </Typography>
        </>
      )}
    </Card>
  );
}
